import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface SplitDetailPanelProps {
  listTitle?: string;
  detailTitle?: string;
  list: ReactNode;
  detail: ReactNode;
  className?: string;
  listClassName?: string;
  detailClassName?: string;
}

export default function SplitDetailPanel({
  listTitle,
  detailTitle,
  list,
  detail,
  className,
  listClassName,
  detailClassName,
}: SplitDetailPanelProps) {
  return (
    <section className={cn('grid gap-4 lg:grid-cols-[minmax(0,22rem)_minmax(0,1fr)]', className)}>
      <article className={cn('overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm', listClassName)}>
        {listTitle && (
          <header className="border-b border-gray-100 px-4 py-3">
            <h2 className="text-sm font-semibold text-gray-900">{listTitle}</h2>
          </header>
        )}
        <div className="max-h-[65vh] overflow-y-auto" role="region" aria-label={listTitle || 'Event list'}>
          {list}
        </div>
      </article>

      <article
        className={cn('overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm', detailClassName)}
      >
        {detailTitle && (
          <header className="border-b border-gray-100 px-5 py-3">
            <h2 className="text-sm font-semibold text-gray-900">{detailTitle}</h2>
          </header>
        )}
        <div className="p-5" role="region" aria-label={detailTitle || 'Event details'}>
          {detail}
        </div>
      </article>
    </section>
  );
}
